module.exports = __webpack_public_path__ + "static/img/Advertisement.de36e7c.gif";


//////////////////
// WEBPACK FOOTER
// ./static/img/Advertisement.gif
// module id = UBiE
// module chunks = 1